import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { STRINGS } from "../Strings";
import { FiArrowRight } from "react-icons/fi";
import { LuUsers, LuActivity, LuHeart, LuSparkles } from "react-icons/lu";

// Picha zote za kadi 4 zinazohusiana na wanufaika
import serveImg1 from '../assets/elders.jpg';
import serveImg2 from '../assets/addicts.jpg';
import serveImg3 from '../assets/youth.jpg';
import serveImg4 from '../assets/poor.jpg';

export default function WhoWeServe(props) {
    const appContext = useContext(AppContext);
    const language = appContext.language || "sw";
    const s = STRINGS.homeWhoWeServe;

    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Space for initialization if needed
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    // Ramani ya Icons kwa makundi 4 ya wanufaika
    const getGroupIcon = (index) => {
        const icons = [
            <LuHeart size={20} />,
            <LuActivity size={20} />,
            <LuSparkles size={20} />,
            <LuUsers size={20} />
        ];
        return icons[index] || <LuUsers size={20} />;
    };

    // Ramani ya picha kwa kila kadi
    const getGroupImage = (index) => {
        const images = [serveImg1, serveImg2, serveImg3, serveImg4];
        return images[index];
    };

    if (ready) {
        return (
            <div className="MainBodySection who-we-serve-wrapper">
                <div className="container">
                    
                    {/* Header Layout */}
                    <div className="row align-items-end mb-5">
                        <div className="col-12 col-lg-6">
                            <span className="serve-kicker font-semi-bold text-uppercase">
                                {s.topTag[language]}
                            </span>
                            <h2 className="title-font-bold serve-main-heading mt-2 mb-0">
                                {s.heading[language]}
                            </h2>
                        </div>
                        <div className="col-12 col-lg-5 offset-lg-1 mt-3 mt-lg-0">
                            <p className="font-regular serve-lead-desc mb-0">
                                {s.subHeading[language]}
                            </p>
                        </div>
                    </div>

                    {/* Interactive Showcase Matrix Grid */}
                    <div className="row g-4 mt-2">
                        {s.groups.map((group, idx) => (
                            <div className="col-12 col-md-6 col-lg-3" key={idx}>
                                <div className="premium-serve-card position-relative overflow-hidden shadow-3">
                                    
                                    {/* Pure JSX Structural Image Container */}
                                    <div className="serve-card-image-box">
                                        <img 
                                            src={getGroupImage(idx)} 
                                            alt={group.title[language]} 
                                            className="serve-bg-img"
                                        />
                                        <div className="serve-image-gradient-overlay"></div>
                                    </div>

                                    {/* Static Content Layout (Inasomeka kila wakati) */}
                                    <div className="serve-card-static-content z-index-3">
                                        <div className="serve-badge-icon">
                                            {getGroupIcon(idx)}
                                        </div>
                                        <h4 className="title-font-bold text-white serve-card-title mt-3">
                                            {group.title[language]}
                                        </h4>
                                    </div>

                                    {/* Hover Interactive Expansion Slide Layer */}
                                    <div className="serve-card-hover-layer z-index-4 d-flex flex-column justify-content-between">
                                        <div>
                                            <span className="font-bold hover-metric-tag">{group.metric[language]}</span>
                                            <h4 className="title-font-semi-bold text-white mt-2 mb-3">
                                                {group.title[language]}
                                            </h4>
                                            <p className="font-regular text-white-80 serve-hover-desc">
                                                {group.description[language]}
                                            </p>
                                        </div>
                                        
                                        <div className="pt-3 border-top-glow-light">
                                            <span className="font-semi-bold text-white small-action-text d-inline-flex align-items-center gap-2">
                                                {s.cardActionText[language]} <FiArrowRight size={14} />
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "450px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}